import { useMediaQuery, useTheme } from '@mui/material';

export default function Headings(props: {heading: string}) {
    const theme = useTheme();
    // const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
    const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <>
            <div className="ui-position--relative">
                <h2 className="ui-typo--h2 ui-position--relative ui-text--capitalize ui-font-weight--medium">{props.heading}</h2>
                <div className={ltsm ? "ui-padding--12" : "ui-padding--24"}></div>
                <p className="app-font--secondary ui-opacity--low ui-nowrap ui-position--absolute ui-bottom">&lt;{props.heading}&gt;&lt;\{props.heading}&gt;</p>
            </div>
        </>
    )
}
